import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { UrlConstants } from "@lib/titan2/dist/game/Constants";
import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { StringUtil } from "@lib/titan2/dist/util/string/StringUtil";
import { WebUtil } from "@lib/titan2/dist/util/web/WebUtil";
import * as PIXI from "pixi.js";
import gsap from "gsap";
import { DebugPath } from "../DebugPath";
/**
 * Game.ts
 */
export class Game extends AbstractGameView {
    create() {
        super.create();
        Logger.addObjectRef(this, "Game");
        Logger.addObjectRef(PIXI, "PIXI");
        const defaultTickerSpeed = PIXI.Ticker.shared.speed;
        const defaultGsapSpeed = gsap.globalTimeline.timeScale();
        window.setSpeed = x => {
            PIXI.Ticker.shared.speed = x * defaultTickerSpeed;
            gsap.globalTimeline.timeScale(x * defaultGsapSpeed);
        };
        window.__PIXI_TICKER__ = {
            get speed() {
                return PIXI.Ticker.shared.speed;
            },
            set speed(x) {
                PIXI.Ticker.shared.speed = x * defaultTickerSpeed;
                gsap.globalTimeline.timeScale(x * defaultGsapSpeed);
            }
        }; // for PIXI inspector
        // @ts-ignore for debugPath
        gsap.core.Tween.prototype.debugPath = function () { DebugPath.attach(this); };
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(CommonGameEvent.INITIALISE, this.handleInitialise);
    }
    handleInitialise() {
        this.createMain();
        this.createMessageBar();
        this.createNavigation();
        this.createTestDisplay();
        this.renderer.forceResize();
        this.createGameHistory();
        this.renderer.hideMask();
    }
    createBackground() {
        this.gameBackground = this.factory.createGameBackground();
        this.addComponent(this.gameBackground);
    }
    createMain() {
        this.main = this.factory.createMain();
        this.addComponent(this.main);
    }
    createMessageBar() {
        this.gameMessageBar = this.factory.createMessageBar();
        this.addComponent(this.gameMessageBar);
    }
    createNavigation() {
        this.GameNavigation = this.factory.createNavigation();
        this.addComponent(this.GameNavigation);
    }
    createTestDisplay() {
        let parameter = WebUtil.getUrlParameter(UrlConstants.TEST);
        let active = StringUtil.isTrue(parameter);
        if (active) {
            this.testDisplay = this.factory.createTestDisplay();
            this.main.addChild(this.testDisplay);
        }
    }
    createGameHistory() {
        this.gameHistory = this.factory.createGameHistory();
        this.addComponent(this.gameHistory);
    }
    addComponent(component) {
        if (component) {
            this.addChild(component);
        }
    }
    removeComponent(component) {
        if (component) {
            this.removeChild(component);
        }
    }
}
//# sourceMappingURL=Game.js.map